import { setCookieValue } from '@do/seashell/utils';
import { useEffect } from 'react';
import { GITHUB_STUDENT_PACK_COOKIE } from '../constants';

/**
 * Sets a cookie with value true if the query param is github-student-pack
 *
 */
const useGithubStudentCookie = (isGitHubStudentVariant: boolean): void => {
  useEffect(() => {
    if (isGitHubStudentVariant) {
      setCookieValue(GITHUB_STUDENT_PACK_COOKIE, 'true');
    }
  }, [isGitHubStudentVariant]);
};

export default useGithubStudentCookie;
